import React from 'react';
import { Box, Text } from '../../../../../ui-kit';
import theme from '../../../../../ui-kit/themes/theme';
import { SummaryContent } from '../../../Content';
import { editCopyByReplaceString } from '../../../../../utilities/copyFunctions';
import * as COPY from '../../utilities/copy';

const ParkingFeeMessage = ({ dailyParkingFee }) => {
  if (!dailyParkingFee) return null;

  return (
    <Box mb={4}>
      <SummaryContent.Description>
        <Text color={theme.colors.deepLakeBlue[100]} fontSize={0} fontWeight={500} lineHeight={18}>
          {editCopyByReplaceString(COPY.DAILY_PARKING_FEE, dailyParkingFee, '<FEE>')}
        </Text>
      </SummaryContent.Description>
    </Box>
  );
};

export default ParkingFeeMessage;
